import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { Avatar } from "@whoosh/design-system/src/components/display";
import { PersonFilledIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  VStack,
  HStack,
  Text,
  Pressable,
} from "@whoosh/design-system/src/components/primitive";

import { SignInFooter_session$key } from "./__generated__/SignInFooter_session.graphql";

type Props = {
  sessionRef: SignInFooter_session$key | null;
  onSignInPress: () => void;
};
export const SignInFooter = ({ sessionRef, onSignInPress }: Props) => {
  const session = useFragment(SignInFooterFragmentString, sessionRef);
  const hasAnonymousCustomerProfile =
    session?.currentClientProfile?.__typename === "AnonymousCustomerProfile";
  return (
    <VStack
      marginLeft="auto"
      marginRight="auto"
      alignItems="center"
      gap={2}
      paddingBottom={6}
    >
      {hasAnonymousCustomerProfile ? (
        <>
          <Box
            width={24}
            height={24}
            backgroundColor="surface-dividers"
            alignItems="center"
            justifyContent="center"
            style={{ borderRadius: 4 }}
          >
            <PersonFilledIcon />
          </Box>

          <HStack gap={1}>
            <Text
              variant="mainSmallMedium"
              color="text-secondary"
            >{t`Already in this booking?`}</Text>
            <Pressable onPress={onSignInPress}>
              <Text color="text-main-primary">{t`Sign In`}</Text>
            </Pressable>
          </HStack>
        </>
      ) : (
        <>
          <Avatar
            size="tiny"
            firstName={session?.user?.firstName}
            lastName={session?.user?.lastName}
          />
          <HStack gap={1}>
            <Text
              variant="mainSmallMedium"
              color="text-secondary"
            >{t`Signed In As`}</Text>
            <Text>{session?.user?.fullName}</Text>
          </HStack>
        </>
      )}
    </VStack>
  );
};

const SignInFooterFragmentString = graphql`
  fragment SignInFooter_session on Session {
    currentClientProfile {
      __typename
    }
    user {
      fullName
      firstName
      lastName
    }
  }
`;
